import React from 'react';

import parse, { Element, HTMLReactParserOptions } from 'html-react-parser';
import DirectoryWidget from '../directory/DirectoryWidget';
import { sanitize } from './SanitizeHTML';

const options: HTMLReactParserOptions = {
  replace: (domNode) => {
    if (domNode['attribs']) {
      const { attribs, name } = domNode as Element;

      if (name === 'shortcode' && attribs.name === 'users_group') {
        const { tags, house, title, nb_user } = attribs;
        return (
          <DirectoryWidget
            title={title}
            tagSlugs={tags.split(',').map((t) => t.trim())}
            house={parseInt(house.trim())}
            nbUserToDisplay={parseInt(nb_user)}
          />
        );
      }
    }
  },
};

const HTMLContent = ({ html, className = '' }): JSX.Element => {
  // N.B. shortcode tag and attributes must be declared in SanitizeHTML default options
  const safeHtml = sanitize(html);

  const el = parse(safeHtml, options);

  return <div className={`wp-content ${className}`}>{el}</div>;
};
export default HTMLContent;
